import {create} from "zustand";
import {postVerifyTopUpService} from "../services/wallet/postVerifyTopUp.service";

export const useBalanceStore = create((set, get) => ({
  balance: 0,
  balanceVisible: false,
  bankAccountModalVisible: false,
  withdrawalModalVisible: false,
  transferModalVisible: false,
  addPagoMovilModalVisible: false,
  pagoMovilRegistrationModalVisible: false,
  pagoMovilListModalVisible: false,
  pendingAction: null, // 'deposit' | 'withdrawal' | null
  setPendingAction: action => {
    set({pendingAction: action});
  },
  clearPendingAction: () => {
    set({pendingAction: null});
  },
  handleWithdrawalModal: () => {
    const withdrawalModalVisible = !get().withdrawalModalVisible;
    set({withdrawalModalVisible});
  },
  handleBalanceVisible: () => {
    const balanceVisible = !get().balanceVisible;
    set({balanceVisible});
  },
  handleBankAccountModal: (skipVerifyService = false) => {
    // Only run postVerifyTopUpService if the modal is open and about to close
    // and if we're not skipping the service call
    if (get().bankAccountModalVisible && !skipVerifyService) {
      postVerifyTopUpService();
    }
    const bankAccountModalVisible = !get().bankAccountModalVisible;
    set({bankAccountModalVisible});
  },
  handleTransferModal: () => {
    const transferModalVisible = !get().transferModalVisible;
    set({transferModalVisible});
  },

  handleAddPagoMovilModal: () => {
    const addPagoMovilModalVisible = !get().addPagoMovilModalVisible;
    set({addPagoMovilModalVisible});
  },

  handlePagoMovilRegistrationModal: () => {
    const pagoMovilRegistrationModalVisible = !get().pagoMovilRegistrationModalVisible;
    set({pagoMovilRegistrationModalVisible});
  },

  handlePagoMovilListModal: () => {
    const pagoMovilListModalVisible = !get().pagoMovilListModalVisible;
    set({pagoMovilListModalVisible});
  },
}));
